import Fetcher from "../../../Common/Fetch";
import usePostRemoveTradeLot from "../../../Api/usePostRemoveTradeLot";
import Popup from "../../../Popups/Popup";
import React, { useState, useEffect } from "react";

export function GetMyLotsPromise() {
    console.log('GetMyLotsPromise');
    return Fetcher("/MyActivityApi/GetMyLots", {
        method: 'GET', headers: { 'Content-Type': 'application/json' }
    })
        .then(res => res.json());
}

export function GetLotsWithMyBetsPromise() {
    console.log('GetLotsWithMyBetsPromise');
    return Fetcher("/MyActivityApi/GetLotsWithMyBets", {
        method: 'GET', headers: { 'Content-Type': 'application/json' }
    })
        .then(res => res.json());
}

export function GetLotsWithMyApplicationsPromise() {
    console.log('GetLotsWithMyApplicationsPromise');
    return Fetcher("/MyActivityApi/GetLotsWithMyApplications", {
        method: 'GET', headers: { 'Content-Type': 'application/json' }
    })
        .then(res => res.json());
}